export enum LoginFormState {
    FillIn,
    RequestingCode,
    Error,
    MsLogin,
    FillInPassword,
}
